import React, { Component } from "react";
import { getSiteLocaleRootUrl, RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import { convertToEidaClientProfile, EIDAClientProfile } from "@eres/ssoapi/entities";
import SSORegContextWrapper, { ISSORegContext, SSORegContext, Step } from "@my-dld/contexts/RegisterContext";
import { Route } from "react-router";
import AppSelector from "./AppSelector";
import EidForm from "./EidForm";
import Complete from "./Complete";
import { AppContext } from "@my-dld/contexts/AppContext";
import { I8N, LocaleUtil } from "@eres/core";
import { SSOApp } from "../../../../../typings/global";
import { AppConstants } from "../../../../configApp";
import urlParser from "urijs";
import * as base64 from "js-base64";
import { IAppLoginState } from "../../index";
import { navigate } from "@my-dld/utils/StoreUtils";
import { SSOApi } from "@eres/ssoapi";
import { exToMessage } from "@eres/ssoapi/api";
import Popup from "@my-dld/components/Popup/Popup";
import { JQModal } from "@my-dld/components/Popup/Utils";


function getTitle( step: Step ): string {
	switch ( step ) {
		case Step.app:
			return Strings.select_app_to_register;
		case Step.eid:
			return Strings.enter_you_emirates_id_number;
		case Step.confirm:
			return Strings.verify_your_personal_details;
		case Step.verify:
			return Strings.verify_your_personal_details;
		case Step.profile_confirm:
			return Strings.verify_your_personal_details;
		case Step.uid:
			return Strings.create_user_name_pwd;
		case Step.done:
			return "";

	}
}

function getIconClass( step: Step ): string | undefined {
	switch ( step ) {
		case Step.app:
			return "icon-app-selection";
		case Step.eid:
			return "icon-enter-EID";
		case Step.confirm:
			return "icon-personal-detail";
		case Step.verify:
			return "icon-verify-detail";
		case Step.profile_confirm:
			return "icon-verify-detail";
		case Step.uid:
			return "icon-username-pssword";
		case Step.done:
			return "";

	}
}

function getStepCount( step: Step, ctx: ISSORegContext ): number {
	const steps = getSteps( ctx );
	let ox = steps.indexOf( step );
	if ( ox === -1 ) return 0;
	return ox + 1;
}

function getSteps( ctx: ISSORegContext ): Step[] {
	return ctx.mode === "uaepass" ? config.steps.uaepass : config.steps.eida;
}

const config = {
	steps: {
		eida: [ Step.app, Step.eid, Step.confirm, Step.verify, Step.profile_confirm, Step.uid ],
		uaepass: [ Step.app, Step.eid, Step.profile_confirm, Step.uid ],
	}
};

interface Prop extends RoutedViewProps<{ appId: string }> {

}


interface State {
	eid?: string;
	error?: string;
	profile?: EIDAClientProfile;
	ready: boolean;
	confirmCancel: boolean;
}

class SSORegister extends Component<Prop, State> {
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

	constructor( props: Prop ) {
		super( props );
		this.state = {
			eid: window.setOTP ? "784198063190791" : "784", //"784"
			ready: false,
			confirmCancel: false,
		};
	}

	onUPOky = () => {
		this.setState( {
			ready: true,
		} );
	};

	render() {
		const pp = this.props.match.path;
		const { ready } = this.state;
		return (
			<SSORegContextWrapper>
				<React.Fragment>
                    <div className="auth-container h-100">
						<div className="container">
							<div className="row g-0">
                                <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 m-auto">
                                    <div className="auth-container-form card">
                                        <UaePassHandler
                                            onOKy={this.onUPOky}
                                            query={this.props.location.search} />
                                        {ready && <>
                                            <StepInfo />
                                            <Route path={[pp + "/", pp + ""]} component={AppSelector} />
                                            <Route
                                                path={pp + "/app/:appId"} component={EidForm}
                                                exact={true} />
                                            <Route path={pp + "/done"} component={Complete} exact={true} />
                                        </>}
                                        <button
                                            className="btn btn-grey mt-2" type="button"
                                            onClick={this.onCancel}>{Strings.cancel}</button>
                                    </div>
                                </div>
								{ this.state.confirmCancel &&
									<div className="modal-logout">
										<Popup
											id={ "cancel-confirm" }
											showCloseButton={ true }
											clickOutsideToDismiss={ false }
											showIcon={ false }
											noTitle={ false }>
											<div className="cancel-icon">
												<i className="fa fa-times"/>
											</div>
											<p className="logout-text">
												{ Strings.confirm_reg_cancel }
											</p>
											<div>
												<button
													className="btn btn_1 btn-block mb-2" type="button"
													onClick={ this.cancelReg }>{ Strings.yes }</button>
												<button
													className="btn btn-grey btn-block" type="button"
													onClick={ this.dismiss }>{ Strings.no }</button>
											</div>
										</Popup>
									</div>
								}
								<div className="col-md-12 sso-footer-txt">
                                        <span>
                                            { Strings.if_issue_with_login }
                                    </span>
									<div>
										<a
											href="mailto:info@dubailand.gov.ae"
											className="underline">info@dubailand.gov.ae</a>
										<span>+971-8004488</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</React.Fragment>
			</SSORegContextWrapper>
		);
	}

	dismiss = () => {
		JQModal( "cancel-confirm" ).hide( () => {
			this.setState( { confirmCancel: false } );
		} );

	};
	cancelReg = () => {
		window.location.href = getSiteLocaleRootUrl();
	};
	onCancel = () => {
		this.setState( { confirmCancel: true }, () => {
			JQModal( "cancel-confirm" ).show();
		} );
	};
}

interface UPPros {
	onOKy: () => void;
	query?: string;
}

interface UPState {
	error?: string;
	ready: boolean;
}

class UaePassHandler extends Component<UPPros, UPState> {
	static contextType = SSORegContext;
	context!: React.ContextType<typeof SSORegContext>;

	constructor( props: UPPros ) {
		super( props );
		this.state = {
			ready: false,
		};
	}

	loadProfile = () => {
		SSOApi.register.loadUaePassProfile().then( x => {
			this.context.update!( { profile: convertToEidaClientProfile( x.data ) } );
			this.setState( { ready: true }, () => {
				this.props.onOKy();
				navigate( `/sso/register/app/${ this.context.app!.id }` );
			} );
		} ).catch( e => {
			exToMessage( e ).then( message => {
				this.setState( {
					ready: false,
					error: message.error,
				} );
			} );

		} );
	};

	componentDidMount() {
		if ( this.props.query ) {
			let q = urlParser( this.props.query ).query( true ) as any;
			if ( q.state ) {
				const state = JSON.parse( base64.decode( q.state ) ) as IAppLoginState;
				if ( state.module === "uaepass" && state.mode === "reg" ) {
					if ( q.error ) {
						this.setState( { error: q.error } );
						return;
					}
					const rApps = window.ssoApps.filter( x => x.signUpUrl != null && x.isLive === true );
					const app = rApps.find( x => x.id + "" === state.app );
					this.context.update!( { mode: "uaepass", step: Step.profile_confirm, app: app } );
					this.loadProfile();
					return;
				}
			}
		}
		this.setState( {
			ready: true,
		} );
		this.props.onOKy();
	}

	render() {
		const { error, ready } = this.state;
		if ( this.state.error ) {
			return <>
				<div className="invalid-feedback invalid-feedback-x">
					{ error }
				</div>
				<button
					className="btn btn_1 btn_style1 btn-block"
					onClick={ this.goHome }>{ Strings.home }</button>
			</>;
		} else if ( !ready ) {
			return <div
				className={ "d-flex align-items-center justify-content-center" }>
				<div className="relative spinner-border " role="status">
					<span className="sr-only">Loading...</span>
				</div>
			</div>;
		}
		return null;
	}

	goHome = () => {
		navigate( "/login" );
	};
}


export default SSORegister;

class StepInfo extends Component {
	static contextType = SSORegContext;
	context!: React.ContextType<typeof SSORegContext>;

	render() {
		const { step } = this.context;
		if ( step === Step.done ) return null;
		let current = getStepCount( step, this.context );
		let totalSteps = getSteps( this.context ).length;
		const icon = getIconClass( step );
        return <div className="auth-title">
			{ icon == undefined &&
				<span className={ icon }/>
			}
			<div className="register-step-number hide">
				{ Strings.sso_reg_label.formatUnicorn( {
					total: I8N.locale() === "ar" ? totalSteps.toLocaleString( "ar-AE" ) : totalSteps,
					current: I8N.locale() === "ar" ? current.toLocaleString( "ar-AE" ) : current
				} ) }
                {getTitle(step)}
            </div>
            <span>{Strings.register_as_bussiness_users} </span>
		</div>;
	}
}

interface AppProps {
	app: SSOApp,
	onClick?: ( app: SSOApp ) => void;
	extraClass?: string;
}

export class SSOAppView extends Component<AppProps, any> {
	static defaultProps = {
		extraClass: ""
	};

	render() {
		const { app, extraClass, onClick } = this.props;
		const c = "sso-app-item flex-grid " + extraClass;
		let icnStyle = {};
		let iconUrl = LocaleUtil.getLocalValue( { en: app.iconEn, ar: app.iconAr } );
		iconUrl = iconUrl ? iconUrl : app.icon ? LocaleUtil.getLocalValue( app.icon ) : AppConstants.rootUrl + "assets/img/land_department.png";

		return <div
			className={ c } key={ app.id } onClick={ () => {
			onClick && onClick( app );
		}
		}>
            {/*<div className="sso-app-item-inner">
				<img
					className={ "sso-app-logo " + "sso-app-logo-" + app.id } src={ iconUrl }
					style={ icnStyle }
					alt="app logo"/>
			</div>*/}
            <div className="entity-name">
                <span>Selected Application</span>
                <span>{LocaleUtil.getLocalValue(app.name)}</span>
            </div>
		</div>;
	}
}
